import React, { Component } from 'react';
import { isEmpty } from 'lodash'
import PaygPopupInfo from '../paygPopupInfo';
import { Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core';
import { TableLayout } from '../Stock/containers/Layout';
import TableFooterPagination from '../../../commonModules/interface/TableFooterPagination';

class Insolvables extends Component{
    state = {
        clientList:[],
        confirm:'none',
        currentClient: {},
        popUp: false,
        loading: true
    }
    componentDidMount = async () => {
        console.log('=================ENDS===================');
        console.log(this.props.ENDS);
        console.log('====================================');
        if (isEmpty(this.props.ENDS)){
            // this.getInsolvables()
            await this.props.getCustomRecoveryList("End")
        }
        this.setState({ loading: false})
    }
    
    getInsolvables = async () => { // move in redux
        // try {
        //     const response = await fetch("/recovery/history/all", {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
        //         },
        //         body: JSON.stringify({
        //             list:'End'
        //         }),
        //         credentials: 'same-origin',
        //     });
        //     const clientList = await response.json();
        //     const clients = []
        //     clientList.content.info.map((box, i)=>{
        //         clientList.content.name.map((columnName, j) =>{
        //             clients[i] = {...clients[i], [columnName]:box[j] }
        //         })
        //     })
        //     this.setState({ clientList : clients });
        //     console.log('IN getInsolvables ',{clientList});
        // } catch (err) {
        //     console.log(err);
        // }
        await this.props.getCustomRecoveryList("End")
        this.setState({ loading: false})
    }
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }

    displayClientList = () => {
        const { CLIENTS, ENDS, STATE } = this.props;
        const { currentPage, rowsPerPage } = this.state;
        if(ENDS.length < 1) {
            return
        }
        
        let fetchInfoFor = ENDS.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).filter(boxAssoId => !CLIENTS[boxAssoId].resume.alert_info )
        console.log('====================================');
        console.log({ fetchInfoFor});
        console.log('====================================');

        if (!isEmpty(fetchInfoFor) && !STATE.paygClients.fetching ){
            this.props.getSelectedPaygInfo("alert", fetchInfoFor, "alert_info") 
        }

        return ENDS.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( ID => {
            let client = CLIENTS[ID].resume
            return(
                <TableRow key={client.idBox} onClick={()=>this.setState({currentClient:client, popUp:true})}>
                    <TableCell >{client.getLastRecoveryAction && new Date(client.getLastRecoveryAction.timeCreation).toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</TableCell>
                    <TableCell>{client.idBox}</TableCell>
                    <TableCell>{client.clientName}</TableCell>
                    <TableCell>{client.getLastRecoveryAction && client.getLastRecoveryAction.comment}</TableCell>
                    <TableCell></TableCell>                                    
                </TableRow>
            )
        })
    }
    render(){
        const { ENDS, CLIENTS } = this.props;
        return(
            <div>
                {this.state.popUp &&
                    <PaygPopupInfo 
                        // paygoID={'d3a75ab8-75'}
                        boxAssoId={this.state.currentClient.boxAssoId}
                        userID={this.state.currentClient.userID}
                        paygoID={this.state.currentClient.idBox}
                        info={this.state.currentClient.info}
                        userInfo={this.state.currentClient}
                        closePopup={()=>this.setState({popUp:false})}
                        USER_INFO_LIST = {["USER", "OTHER"]}
                        BOX_INFO_LIST = {["INSTALLS", "BOX", "SYSTEM"]}
                        PAYMENTS_INFO_LIST = {["RESUME", "LIST"]} 
                        SUIVI_INFO_LIST
                        recovery 
                        default_tab = {"SUIVI"}
                    />
                }
                
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Box ID</TableCell>
                            <TableCell>Nom</TableCell>
                            <TableCell>Info</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    
                    {ENDS && 
                        this.displayClientList()
                    }
                    </TableBody>
                    <TableFooterPagination
                        colSpan={5}
                        items={ENDS} 
                        onChangePage={this.onChangePage} 
                        initialPage={this.state.currentPage} 
                    />
                </TableLayout>
            </div>
        )
    }
}

export default Insolvables;